module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna@2x-aa7ff7fd.png";